import React, {Component} from 'react';

export default class RadioInput extends Component {

    renderOptions(inputName, listValues) {

        return listValues.map((el, i)=>{

            const rndKey=Math.floor(Math.random() * Math.floor(1000000));
            return (
                <React.Fragment key={rndKey}>
                    <input name={inputName} type={"radio"} value={el}/>{el}<br/>
                </React.Fragment>
            );
        });
    }

    render() {
        const question = this.props.question;
        const name = this.props.name;
        const options = this.props.options;

        if(!options) {
            return null;
        }

        return (
            <div>
                {question}<br/>
                {this.renderOptions(name, options)}
            </div>
        )
    }
}
